import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState({ loading: true, success: false, message: '' });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const verify = async () => {
      try {
        const res = await fetch(`/api/auth/verify-email?token=${encodeURIComponent(token || '')}`);
        const data = await res.json();
        if (res.ok && data.success) {
          setStatus({ loading: false, success: true, message: 'Votre email a été vérifié. Vous pouvez vous connecter.' });
          setTimeout(() => navigate('/login'), 3000);
        } else {
          setStatus({ loading: false, success: false, message: data.message || 'Lien invalide ou expiré.' });
        }
      } catch (e) {
        setStatus({ loading: false, success: false, message: 'Erreur de vérification.' });
      }
    };
    verify();
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-gray-800 border border-gray-700 rounded-2xl p-8 text-center">
        {status.loading ? (
          <div className="text-gray-300">Vérification en cours...</div>
        ) : status.success ? (
          <div className="text-green-400 font-medium">{status.message}</div>
        ) : (
          <div className="text-red-400 font-medium">{status.message}</div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;


